import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useActiveRecordRef from '../../hooks/use-active-record-ref';
import { AdminTabs } from '../../pages/admin/admin-utils';
import type { ImportFormBackgroundJobDetails } from '../../redux/slices/background-job-slice';
import type { BackgroundJobPanelItemProps } from './background-job-panel.component';
import BaseJobPanelItem from './base-job-panel-item.component';

const FormBackgroundJobItem = ({
  job,
  onRemove,
}: BackgroundJobPanelItemProps<unknown, ImportFormBackgroundJobDetails>) => {
  const { status, details } = job;
  const { fileName, formConfig, templateFormId, moduleFormId, moduleIcon } = details ?? {};

  const { activeRecordReference } = useActiveRecordRef();
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    if (formConfig) {
      activeRecordReference.current?.addActiveRecord(
        String(formConfig.id),
        moduleIcon ?? '',
        `${formConfig.formCaption.translations?.[0]?.value ?? t('preview-imported-form')}`,
        true,
        {
          jobId: job.id,
          moduleFormId,
          templateFormId,
          config: formConfig,
          administrationTab: AdminTabs.FORMS,
          isFormBuilder: true,
        }
      );
    }
  }, [formConfig, job.id]);

  return (
    <BaseJobPanelItem
      title={t('preview-imported-form')}
      subtitle={fileName ?? ''}
      status={status}
      onRemove={onRemove}
      onClick={handleClick}
    />
  );
};

export default React.memo(FormBackgroundJobItem);
